import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__getOrderDetails = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(order_id) {
    var params, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          params = {
            order_id: order_id,
            include: {
              roadService: 1,
              warranty: 1,
              banks: 1,
              payment_info: 1
            }
          };
          _context.p = 1;
          _context.n = 2;
          return fetcher().get('/finance/get-details', {
            params: params
          });
        case 2:
          res = _context.v;
          return _context.a(2, res || null);
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error("Error getting ARIB order:", _t);
          throw _t;
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function api__getOrderDetails(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default api__getOrderDetails;